"use client"

import { type FragmentOf, readFragment } from "@opensea/graphql"
import { Badge, classNames, Tooltip } from "@opensea/ui-kit"
import { Error } from "@opensea/ui-kit/icons"
import { useTranslations } from "next-intl"
import type { ComponentPropsWithoutRef } from "react"
import { AccountEnforcementBadgeFragment } from "./AccountEnforcementBadge.fragment"

type Props = {
  account: FragmentOf<typeof AccountEnforcementBadgeFragment>
  className?: string
  size?: number
} & Omit<ComponentPropsWithoutRef<typeof Badge>, "children" | "asChild">

export function AccountEnforcementBadge({
  className,
  account: accountKey,
  size = 18,
  ...rest
}: Props) {
  const t = useTranslations("ProfileInfo")
  const account = readFragment(AccountEnforcementBadgeFragment, accountKey)

  if (!account.isCompromised) {
    return null
  }

  return (
    <Tooltip content={t("accountCompromised")}>
      <Badge
        className={classNames("bg-transparent p-0 text-error-1", className)}
        icon={Error}
        iconSize={size}
        variant="info"
        {...rest}
      />
    </Tooltip>
  )
}
